import React, { useState, useRef, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

const ANSWERS = {
  'налоги': 'По вашему режиму УСН вам нужно платить авансовые платежи до 28 апреля, 28 июля, 28 октября. Декларация — до 31 марта следующего года. НДС не облагается.',
  'ндс': 'На режиме УСН НДС не облагается (ст. 346.11 НК РФ). На ОСНО ставка НДС — 22% с 2026 года.',
  'кассовый разрыв': 'Кассовый разрыв — это когда расходы превышают доходы в конкретный день. Khepri предсказывает разрывы на 14 дней вперёд.',
  'контрагент': 'Проверить контрагента можно на вкладке «Контрагенты». Введите ИНН — Khepri покажет риски.',
  'договор': 'Создать договор можно на вкладке «Договоры». Khepri генерирует договор с учётом вашего налогового режима.',
  'счёт': 'Открыть расчётный счёт можно через вкладку «Банки».',
  'помощь': 'Я ИИ-Ко-фаундер Khepri. Могу ответить на вопросы о налогах, договорах, контрагентах, торгах, гарантиях, 1С и банках.',
};

function AIChat() {
  const [messages, setMessages] = useState([
    { from: 'ai', text: '👋 Привет! Я ИИ-Ко-фаундер Khepri. Задайте вопрос о налогах, договорах, контрагентах, тендерах и многом другом.' },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [usage, setUsage] = useState({ remaining: 20, limit_count: 20, plan: 'free' });
  const chatEnd = useRef(null);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    chatEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    fetchUsage();
  }, []);

  const fetchUsage = async () => {
    try {
      const res = await fetch(API + '/ai/usage', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setUsage(d); }
    } catch (err) { console.error(err); }
  };

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;

    setMessages(prev => [...prev, { from: 'user', text }]);
    setInput('');
    setLoading(true);

    try {
      const res = await fetch(API + '/ai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ message: text }),
      });

      if (res.ok) {
        const data = await res.json();
        setMessages(prev => [...prev, { from: 'ai', text: data.answer }]);
        if (data.remaining !== undefined) setUsage(prev => ({ ...prev, remaining: data.remaining }));
      } else {
        setMessages(prev => [...prev, { from: 'ai', text: findAnswer(text.toLowerCase()) }]);
      }
    } catch (err) {
      setMessages(prev => [...prev, { from: 'ai', text: findAnswer(text.toLowerCase()) }]);
    } finally {
      setLoading(false);
    }
  };

  const clearHistory = () => {
    setMessages([{ from: 'ai', text: '👋 Привет! Я ИИ-Ко-фаундер Khepri. Задайте вопрос.' }]);
  };

  const findAnswer = (q) => {
    for (const [key, answer] of Object.entries(ANSWERS)) {
      if (q.includes(key)) return answer;
    }
    return 'Извините, я пока не знаю ответа. Попробуйте спросить про: налоги, НДС, кассовый разрыв, контрагент, договор, счёт, помощь.';
  };

  const limitReached = usage.remaining <= 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 200px)', minHeight: 500 }}>
      {/* Шапка */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 10 }}>
        <h2 style={{ color: '#F7DE8A', margin: 0 }}>🤖 ИИ-Ко-фаундер</h2>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <span style={{ color: limitReached ? '#EF4444' : '#94A3B8', fontSize: 13, fontWeight: 600 }}>
            🤖 Осталось: {usage.remaining}/{usage.limit_count}
          </span>
          <button onClick={clearHistory} style={{ background: 'none', border: '1px solid #8A6636', color: '#94A3B8', cursor: 'pointer', fontSize: 12, padding: '6px 12px', borderRadius: 6 }}>
            Очистить
          </button>
        </div>
      </div>

      {limitReached && (
        <div style={{ marginBottom: 12, padding: 12, background: 'rgba(239,68,68,0.15)', border: '1px solid #EF4444', borderRadius: 8, fontSize: 13 }}>
          <strong style={{ color: '#EF4444' }}>⚠️ Лимит исчерпан</strong>
          <p style={{ color: '#94A3B8', marginTop: 4 }}>
            Перейдите на платный тариф в разделе «Тарифы» для увеличения лимита.
          </p>
        </div>
      )}

      {/* Сообщения */}
      <div style={{ flex: 1, overflowY: 'auto', marginBottom: 12, padding: '0 4px', minHeight: 200 }}>
        {messages.map((m, i) => (
          <div key={i} style={{ marginBottom: 10, display: 'flex', justifyContent: m.from === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '80%',
              padding: '10px 14px',
              borderRadius: 12,
              background: m.from === 'user' ? '#F7DE8A' : '#1E293B',
              color: m.from === 'user' ? '#0F172A' : '#F8FAFC',
              fontSize: 14,
              lineHeight: 1.5,
              border: m.from === 'ai' ? '1px solid #8A6636' : 'none',
              whiteSpace: 'pre-wrap',
            }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'flex-start' }}>
            <div style={{ padding: '10px 14px', borderRadius: 12, background: '#1E293B', color: '#94A3B8', fontSize: 14, border: '1px solid #8A6636' }}>
              Думаю...
            </div>
          </div>
        )}
        <div ref={chatEnd} />
      </div>

      {/* Панель ввода — ПОДНЯТА ВЫШЕ */}
      <div style={{ display: 'flex', gap: 8, paddingBottom: 40 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder={limitReached ? 'Лимит исчерпан...' : 'Напишите что-нибудь...'}
          disabled={limitReached || loading}
          style={{
            flex: 1,
            padding: 14,
            background: '#0F172A',
            border: '1px solid #8A6636',
            borderRadius: 8,
            color: '#F8FAFC',
            fontSize: 14,
            opacity: limitReached ? 0.5 : 1,
          }}
        />
        <button
          onClick={send}
          disabled={limitReached || loading}
          style={{
            padding: '14px 28px',
            background: limitReached ? '#334155' : '#F7DE8A',
            color: limitReached ? '#94A3B8' : '#0F172A',
            border: 'none',
            borderRadius: 8,
            cursor: limitReached || loading ? 'default' : 'pointer',
            fontWeight: 700,
            fontSize: 14,
          }}
        >
          Отправить
        </button>
      </div>
    </div>
  );
}

export default AIChat;